import type React from 'react';

import { Button, Modal, ModalBody, ModalFooter } from '@change/ds-core-ui';

import type { ReadyToSharePostWithPlatform } from 'src/app/shared/api/readyToShare';

import { Instructions } from './components/Instructions';
import { ModalTitle } from './components/ModalTitle';
import { PostPreview } from './components/PostPreview';
import { useSharePreviewModal } from './hooks/useSharePreviewModal';

type SharePreviewModalProps = {
	isOpen?: boolean;
	onClose: () => void;
	readyToSharePost: ReadyToSharePostWithPlatform;
};

const transformSuggestedMessage = (suggestedMessage?: string | null): string => {
	if (!suggestedMessage) return '';
	return suggestedMessage.replace(/\n/g, '<br/>');
};

export const SharePreviewModal: React.FC<SharePreviewModalProps> = ({ onClose, isOpen = false, readyToSharePost }) => {
	const {
		data: { shareAction },
		actions: { beforeShare, afterShare, trackView },
	} = useSharePreviewModal(onClose, readyToSharePost);

	if (!isOpen || !shareAction) return undefined;

	const { ShareAction } = shareAction;

	trackView(); // FIXME should this be in a useEffect???

	return (
		<Modal
			defaultOpen
			onClose={onClose}
			trigger={
				<Button className="hidden" aria-label="Facebook Post">
					Facebook Post
				</Button>
			}
			size="large"
			data-qa="pre-made-post-modal"
			className="z-30 [&>div>div]:max-h-[initial] md:[&>div>div]:col-start-2! md:[&>div>div]:max-w-[524px]! lg:[&>div>div]:col-start-4!"
		>
			<ModalTitle onClose={onClose} />
			<ModalBody className="flex max-h-[initial]! flex-col gap-6 p-4 md:p-6">
				<PostPreview
					postText={transformSuggestedMessage(readyToSharePost.message)}
					imageUrl={readyToSharePost.images[0]?.url}
					previewTitle={readyToSharePost.title}
				/>
				<Instructions />
			</ModalBody>
			<ModalFooter className="justify-center md:p-6">
				<ShareAction onBeforeAction={beforeShare} onAfterAction={afterShare}>
					<Button variant="primary" data-qa="share-preview-modal-post-action" className="w-full max-w-full">
						Post on Facebook
					</Button>
				</ShareAction>
			</ModalFooter>
		</Modal>
	);
};
